import React, { useRef, useEffect, useMemo, MutableRefObject } from "react";
import { ContainerProps } from "./types";
import { MessageType } from "../../types";
import TextMessage from "./messageItems/textMessage";
import SlotMessage from "./messageItems/slotMessage";
import ActivityMessage from "./messageItems/activityMessage";
import MatchMessage from "./messageItems/matchMessage";
import ChampionshipMessage from "./messageItems/championshipMessage";

const MessageContainer = ({ partner, partners, message, messageReadBy, observer, userId }: ContainerProps) => {
	const container = useRef() as MutableRefObject<HTMLDivElement>;

	const readByMe = useMemo(() => {
		if (!message.readBy) {
			return false;
		}

		if (message.readBy.indexOf(userId) !== -1) {
			return true;
		}

		return false;
	}, [message.readBy]);

	//https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
	useEffect(() => {
		if (!readByMe) {
			if (observer) {
				observer.observe(container.current);
			}
		}

		if (readByMe) {
			observer.unobserve(container.current);
		}

		return () => {
			observer.unobserve(container.current);
		};
	}, [readByMe]);

	// console.log(message.text.messageType);

	switch (message.text.messageType) {
		case MessageType.TEXT: {
			return (
				<TextMessage
					message={message}
					partner={partner}
					partners={partners}
					lastReadByPartners={messageReadBy}
					userId={userId}
					ref={container}
				/>
			);
		}

		case MessageType.SLOT: {
			return (
				<SlotMessage
					message={message}
					partner={partner}
					partners={partners}
					lastReadByPartners={messageReadBy}
					userId={userId}
					ref={container}
				/>
			);
		}

		case MessageType.ACTIVITY: {
			return (
				<ActivityMessage
					message={message}
					partner={partner}
					partners={partners}
					lastReadByPartners={messageReadBy}
					userId={userId}
					ref={container}
				/>
			);
		}

		case MessageType.MATCH: {
			return (
				<MatchMessage
					message={message}
					partner={partner}
					partners={partners}
					lastReadByPartners={messageReadBy}
					userId={userId}
					ref={container}
				/>
			);
		}

		case MessageType.CHAMPIONSHIP: {
			return (
				<ChampionshipMessage
					message={message}
					partner={partner}
					partners={partners}
					lastReadByPartners={messageReadBy}
					userId={userId}
					ref={container}
				/>
			);
		}
	}
};

export default MessageContainer;
